export interface AuditLogEvent {
    eventId: number
    shortName?: string
    description?: string 
};

export interface CoreAuditLogEntry {
    id: string
    timestamp: string
    actor: CoreAuditLogActor
    event?: CoreAuditLogEvent
    source?: CoreAuditLogSource
    additionalInformation?: string
};

export interface CoreAuditLogActor {
    id: string
    uniqueIdentifier?: string
    displayName?: string
    email?: string
    type: AuditLogActorType
};

export interface CoreAuditLogEvent {
    eventId: number
    shortName?: string
    description?: string
};

export interface CoreAuditLogSource {
    moduleTypeName?: string
    type: AuditLogSourceType
    id?: string
    name?: string
};

enum AuditLogSourceType {
    Unknown = 0,
    Module = 1,
    AppToken = 2,
    License = 3,
    Group = 4,
    User = 5,
    Customer = 6,
    SchoolAdminUser = 7,
    InstanceSettings = 8,
    Activity = 9,
    StudentGroup = 10,
    Role = 11,
    PasswordProfile = 12,
    GoogleDevice = 13,
};

export enum AuditLogActorType {
    UNDEFINED = 0,
    USER = 1,
    CONSUMER = 2,
};
